import { addDays, addMonths } from 'date-fns';

import { OnetimePeriod } from '../types';

/**
 * OnetimePeriod 값을 받아서 날짜를 계산하는 함수
 * @param startDate
 * @param period
 */
export function calculatePlanEndDate(startDate: Date, period: OnetimePeriod) {
  const date = new Date(startDate);
  const unit = period.slice(-1); // 'D' 또는 'M'
  const value = parseInt(period.slice(0, -1), 10); // 숫자 값 추출

  let calculatedDate = new Date();

  if (unit === 'D') {
    calculatedDate = addDays(date, value);
  } else if (unit === 'M') {
    calculatedDate = addMonths(date, value);
  }

  return calculatedDate.getTime();
}
